import React, { useState, useEffect, useCallback } from "react";
// import styled from "styled-components";
import { useTable, usePagination, useSortBy } from "react-table";
import {
  Table,
  Row,
  Col,
  Pagination,
  PaginationItem,
  PaginationLink,
  Input,
  Button,
} from "reactstrap";
import Select from "react-select";


const loginUser = JSON.parse(localStorage.getItem("user"));
const loggedInUserId = Number(loginUser?.EmployeeId);

function TableView({ columns, data,customPageSize ,sumhours,sumbillable,estimated,onchangeApprovestatus,curstatus,handleSubmit,handleChange,curstatusList,onSelectionChange}) {
  // Use the state and functions returned from useTable to build your UI
  const [selectedEmployeeIds, setSelectedEmployeeIds] = useState([]);
  
const [selectedOnlyEmployeeIds, setSelectedOnlyEmployeeIds] = useState([]);

  const [curStatus, setcurStatus] = useState(0);
  const [selectAll, setSelectAll] = useState(false);
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page, // Instead of using 'rows', we'll use page,
    // which has only the rows for the active page

    // The rest of these things are super handy, too ;)
    canPreviousPage,
    canNextPage,
    pageOptions,
    pageCount,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns,
      data,

      defaultCanSort: true,
      initialState: { pageIndex: 0 ,
        sortBy: [{ id: "Name", asc: true }]},
    },
    useSortBy,
    usePagination
  );
  useEffect(() => {
    // set the page size to 5.
    setPageSize(customPageSize);
  }, [setPageSize]);

    let optionselect=[];
  optionselect.push({value :0 ,label:"Select"},{value :1 ,label:"Approve"},{value :2 ,label:"Reject"});
  
  let optionselectA=[];
  optionselectA.push({value :0 ,label:"Select"},{value :1 ,label:"Approve"});
  // Render the UI for your table
  // Handle Select All Toggle
  const handleSelectAll = () => {
    if (selectAll) {
      setSelectedEmployeeIds([]);
    } else {
      // Select all Ids from the entire data, not just the current page
      const pendingEmployeeIds = data
        .filter(row => row.approvedStatusRaw !== 1 && row.approvedStatusIdRaw == 0) // Exclude approved rows
        .map(row => row.Id);
      setSelectedEmployeeIds(pendingEmployeeIds);
      onSelectionChange(pendingEmployeeIds);
    }
    setSelectAll(!selectAll);
  };
  const handleCheckboxChange = useCallback(
    (employeeId,rowId,employeeIds, status, approvedStatusRaw, approvedStatusIdR) => {
      if (approvedStatusRaw === 1) return; // 🔒 Do not allow approved

      const currentStatus =
        approvedStatusRaw === 0 && approvedStatusIdR === "Rejected"
          ? 2
          : approvedStatusRaw;

      // Block mixing statuses
      if (
        selectedEmployeeIds.length > 0 &&
        curStatus !== currentStatus
      ) {
        return;
      }

      
      setSelectedEmployeeIds((prevSelected) => {
        if (prevSelected.includes(employeeId)) {
          const updated = prevSelected.filter((id) => id !== employeeId);
          onSelectionChange(updated);
          if (updated.length === 0) {
            setcurStatus(0); // Reset if nothing selected
          }
          return updated;
        } else {
          setcurStatus(currentStatus); // ✅ Now properly sets on select
          const updated = [...prevSelected, employeeId];
          onSelectionChange(updated);
          return updated;
        }
      });

      
        setSelectedOnlyEmployeeIds((prev) =>
    prev.includes(employeeIds) ? prev.filter(id => id !== employeeIds) : [...prev, employeeIds]
  );
    },
    [selectedEmployeeIds, curStatus, onSelectionChange,selectedOnlyEmployeeIds]
  );

  const isActionDisabled = selectedEmployeeIds.length === 0;
  
 const isSubmitDisabled =
  selectedEmployeeIds.length === 0 ||
  data.some(row => selectedEmployeeIds.includes(row.Id) && row.employeeId === loggedInUserId);

   const hasOwnTaskSelected = data.some(
    (row) => selectedEmployeeIds.includes(row.Id) && row.employeeId === loggedInUserId
  );


  useEffect(() => {
    if (onSelectionChange) {
      onSelectionChange(selectedEmployeeIds);
    }
  }, [selectedEmployeeIds, onSelectionChange]);

  return (
    <>
      {/* <div style={{ width: "100%", overflowY: "auto" }}> */}
      <Row className="mb-2" id="showPageCountInTable">
        <Col sm={2}>
          <select
            className="form-control"
            value={pageSize}
            onChange={(e) => {
              setPageSize(Number(e.target.value));
            }}
          // style={{ width: "140px" }}
          >
            {[5, 10, 20, 30, 40, 50].map((pageSize) => (
              <option key={pageSize} value={pageSize}>
                Show {pageSize}
              </option>
            ))}
          </select>
        </Col>
      </Row>
      {/* <tr>
          <td> */}
      {/* <div style={{ width: "500px", height: "180px", overflow: "auto" }}> */}
      <div
        className="main-div"
      // style={{ width: "500px", height: "180px", overflow: "auto" }}
      >
        <Table hover {...getTableProps()} style={{
          tableLayout: "auto", // controls strict layout
          width: "100%",
          borderCollapse: "separate",
          borderSpacing: "0 10px"
        }}>
          <thead>
            {headerGroups.map((headerGroup, p) => (
              <tr key={p} {...headerGroup.getHeaderGroupProps()}>
                <th s style={{
                  width: "24px",
                  maxWidth: "24px",
                  minWidth: "24px",
                  padding: "0",
                  textAlign: "center"
                }}>
                  <input
                    type="checkbox"
                    checked={selectAll}
                    onChange={handleSelectAll}
                    style={{ width: "15px", height: "15px", margin: 0 }}
                  />
                </th>
                {headerGroup.headers.map((column, index) => (
                  column.render("Header") === "Id" ? null : ( // Hides Id column
                    <th key={index}
                      {...column.getHeaderProps(column.getSortByToggleProps())}
                      style={{
                        ...(column.render("Header") === "Employee"
                          ? {
                            //width: "220px",
                            minWidth: "215px",
                            maxWidth: "215px",
                            whiteSpace: "normal",         // ✅ allow wrap
                            wordBreak: "break-word",      // ✅ break if needed
                            //overflowWrap: "break-word",
                            textAlign: "left",
                            verticalAlign: "middle",
                            padding: "8px 12px"
                          }
                          : column.render("Header") === "Project"
                            ? {
                              //width: "170px",
                              minWidth: "160px",
                              maxWidth: "160px",
                              whiteSpace: "normal",
                              wordBreak: "break-word",
                              //overflowWrap: "break-word",
                              textAlign: "left",
                              verticalAlign: "middle",
                              padding: "8px 12px"
                            }
                            : {
                              whiteSpace: "nowrap",         // ✅ keep nowrap for other columns
                              textAlign: "left",
                              verticalAlign: "middle",
                              padding: "8px 12px"
                            })
                      }}>
                      <span style={{ display: "flex", alignItems: "left", justifyContent: "left", gap: "6px" }}>
                        {column.render("Header")}

                        {(column.render("Header") === "Action" ||
                          column.render("Header") === "Reviewer1" ||
                          column.render("Header") === "Reviewer2" ||
                          column.render("Header") === "Select") ? (
                          <i></i>
                        ) : (
                          <i className="fas fa-exchange-alt fa-rotate-90 ml-3"></i>
                        )}

                      </span>
                    </th>
                  )
                ))}
              </tr>
            ))}
          </thead>
          <tbody {...getTableBodyProps()}>
            {page.map((row, i) => {
              prepareRow(row);
              return (
                <tr key={i} {...row.getRowProps()}
                  style={{
                    opacity: row.original.approvedStatusRaw === 1 ? 0.6 : 1, // dim if approved
                    pointerEvents: row.original.approvedStatusRaw === 1 ? "none" : "auto", // prevent click/select
                    backgroundColor: row.original.approvedStatusRaw === 1 ? "#f8f9fa" : (row.original.approvedStatusRaw === 0 && row.original.approvedStatusIdRaw != 0 ? "#f5c6cb" : "inherit") // optional light gray background
                  }}
                >
                  <td style={{
                    width: "24px",
                    maxWidth: "24px",
                    minWidth: "24px",
                    padding: "0",
                    textAlign: "center"
                  }}>
                    <input
                      type="checkbox"
                      checked={selectedEmployeeIds.includes(row.original.Id)}
                      onChange={() => handleCheckboxChange(row.original.Id, row.original.rawId, row.original.employeeId,row.original.Status, row.original.approvedStatusRaw, row.original.approvedStatusIdR)}
                      style={{ width: "15px", height: "15px", margin: 0 }}
                    />
                  </td>
                  {row.cells.map((cell, k) => {
                    if (cell.column.Header === "Id") return null;

                    const header = cell.column.Header;

                    let style = {
                      whiteSpace: "nowrap",
                      //overflow: "hidden",
                      //textOverflow: "ellipsis"
                    };



                    if (header === "Employee") {
                      style = {
                        whiteSpace: "nowrap",
                        wordBreak: "break-word",
                        overflowWrap: "break-word",
                        minWidth: "200px",
                        maxWidth: "300px"
                      };
                    } else if (header === "Task") {
                      style = {
                        whiteSpace: "normal",
                        wordBreak: "break-word",
                        overflowWrap: "break-word",
                        minWidth: "140px",
                        maxWidth: "200px"
                      };
                    }
                    else if (header === "Description") {
                      style = {
                        whiteSpace: "normal",
                        wordBreak: "break-word",
                        overflowWrap: "break-word",
                        minWidth: "140px",
                        maxWidth: "220px"
                      };

                    }
                    else if (header === "Hours Spent" || header === "Hours Billable") {
                      style = {
                        whiteSpace: "nowrap",        // ❗ prevents word break
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        textAlign: "center"
                      };
                    }

                    return (
                      <td key={k} {...cell.getCellProps()} style={style}>
                        {cell.render("Cell")}
                      </td>
                    );
                  })}
                </tr>
              );
            })}

            {/* Summary Row */}
            <tr>
              <td><h5>Total</h5></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td style={{ textAlign: "center" }}>
                <span style={{ fontSize: "16px", fontWeight: "600" }}>{sumhours}</span>
              </td>
              <td style={{ textAlign: "center" }}>
                <span style={{ fontSize: "16px", fontWeight: "600" }}>{sumbillable}</span>
              </td>
            </tr>
            <tr>
              <td colSpan="6" style={{ textAlign: "left" }}><h6>Total Estimated Hours:</h6></td>

              <td style={{ textAlign: "center" }}>
                <span style={{ fontSize: "16px", fontWeight: "600" }}>{estimated}</span>
              </td>
            </tr>
            {/* Action Row */}
           {loginUser.RoleName == "Admin" ? null : <tr>
              <td><h6>Approve/Reject</h6></td>
              <td></td>
              <td></td>
              <td>
                {curstatus === 2 ? (
                  <span style={{ width: "140px" }}>
                    <Select
                      className="basic-single"
                      classNamePrefix="select"
                      menuPlacement="auto" // or "top"
                      menuPortalTarget={document.body}
                      styles={{
                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                        menu: (base) => ({ ...base, zIndex: 9999 }),
                      }}
                      value={curstatusList}
                      onChange={(e) => onchangeApprovestatus(e.value, e.label)}
                      isSearchable={true}
                      name="color"
                      options={curStatus == 0 ? optionselect : curStatus == 2 ? optionselectA : optionselect}
                    />
                  </span>
                ) : (
                  <span style={{ width: "140px" }}></span>
                )}
              </td>
            <td>
                {curstatus === 2 ? (
                  <Input
                    type="textarea"
                    name="description"
                    aria-label="Enter your text"
                    onChange={(evnt) => handleChange(evnt)}
                    className="form-control"
                    style={{ width: "270px" }}
                  />
                ) : (
                  <Select
                    className="basic-single"
                    classNamePrefix="select"
                    menuPlacement="auto" // or "top"
                    menuPortalTarget={document.body}
                    styles={{
                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                      menu: (base) => ({ ...base, zIndex: 9999 }),
                    }}
                    value={curstatusList}
                    onChange={(e) => onchangeApprovestatus(e.value, e.label)}
                    isSearchable={true}
                    name="color"
                    options={curStatus == 0 ? optionselect : curStatus == 2 ? optionselectA : optionselect}
                    isDisabled={isActionDisabled} 
                  />
                )}
              </td> 
              <td>
                 
                <Button onClick={handleSubmit} style={{ width: "140px" }} disabled={isSubmitDisabled}>
                  Submit
                </Button>
                {hasOwnTaskSelected && (
                  <p style={{ color: "red", fontSize: "14px", marginBottom: "8px" }}>
                    You cannot approve your own task
                  </p>
                )}
              </td>
              <td></td>
              <td></td>
            </tr>}
          </tbody>
        </Table>

      </div>
      {/* </td>
        </tr> */}

      {/* 
        Pagination can be built however you'd like. 
        This is just a very basic UI implementation:
      */}
      <Row className="table-pagination">
        <Col>
          <Pagination
            // size="sm"
            aria-label="Page navigation example"
            className="pagination"
          >
            <PaginationItem>
              <PaginationLink
                first
                onClick={() => gotoPage(0)}
                disabled={!canPreviousPage}
              />
            </PaginationItem>
            <PaginationItem>
              <PaginationLink
                previous
                onClick={() => previousPage()}
                disabled={!canPreviousPage}
              />
            </PaginationItem>
            &nbsp;
            <strong className="mt-1">
              {pageIndex + 1} of {pageOptions.length}
            </strong>
            &nbsp;
            <PaginationItem>
              <PaginationLink
                next
                onClick={() => nextPage()}
                disabled={!canNextPage}
              />
            </PaginationItem>
            <PaginationItem>
              <PaginationLink
                last
                onClick={() => gotoPage(pageCount - 1)}
                disabled={!canNextPage}
              />
            </PaginationItem>
          </Pagination>

          {/* <div className="pagination">
            <button onClick={() => gotoPage(0)} disabled={!canPreviousPage}>
              {"<<"}
            </button>{" "}
            <button onClick={() => previousPage()} disabled={!canPreviousPage}>
              {"<"}
            </button>
            <span>
              Page{" "}
              <strong>
                {pageIndex + 1} of {pageOptions.length}
              </strong>{" "}
            </span>
            <button onClick={() => nextPage()} disabled={!canNextPage}>
              {">"}
            </button>{" "}
            <button
              onClick={() => gotoPage(pageCount - 1)}
              disabled={!canNextPage}
            >
              {">>"}
            </button>{" "}
          </div> */}
        </Col>
        <Col>
          <Row className="table-goto-page">
            <Col sm={12} xs={6} md={7} lg={12}>
              <div
                className="input-group mb-3 float-right"
                style={{ width: "180px" }}
              >
                <div className="input-group-prepend">
                  <label className="input-group-text">Go to page</label>
                </div>
                <input
                  className="form-control"
                  type="number"
                  defaultValue={pageIndex + 1}
                  onChange={(e) => {
                    const page = e.target.value
                      ? Number(e.target.value) - 1
                      : 0;
                    gotoPage(page);
                  }}
                />
              </div>
              {/* <span>Go to page:
              <input
                  className="form-control"
                  type="number"
                  defaultValue={pageIndex + 1}
                  onChange={(e) => {
                    const page = e.target.value
                      ? Number(e.target.value) - 1
                      : 0;
                    gotoPage(page);
                  }}
                  style={{ width: "50px" }}
                />
              </span>{" "} */}
            </Col>
            {/* <Col sm={4} xs={6} md={5} lg={4}></Col> */}
          </Row>
        </Col>
      </Row>
      {/* </div> */}
    </>
  );
}


const TableWithSorPagtn = React.memo((props) => {

  const { thead, onSelectionChange } = props;

const columns = React.useMemo(() => {
  let filteredHead = props.thead.filter((el) => el !== "Id");

  // 🧠 hide checkbox column if user is Admin
  if (props.loginUser?.RoleName === "Admin") {
    filteredHead = filteredHead.filter((el) => el !== "Select");
  }

  return filteredHead.map((el) => ({ Header: el, accessor: el }));
}, [props.thead, props.loginUser]);
  const data = React.useMemo(() => props.trow, [props.trow]);
  return (
    // <Styles>

    <TableView columns={columns} data={data} customPageSize={props.pageSize} sumhours={props.sumhours} sumbillable={props.sumbillable} estimated={props.estimated} onchangeApprovestatus={props.onchangeApprovestatus} curstatus={props.curstatus} handleSubmit={props.handleSubmit} handleChange={props.handleChange} curstatusList={props.curstatusList} onSelectionChange={onSelectionChange} loginUser={props.loginUser}/>
    // </Styles>
  );
});

export default TableWithSorPagtn;
